var map = {
	"./authentication/authentication.module": [
		"../../../../../src/app/authentication/authentication.module.ts"
	],
	"./error/error.module": [
		"../../../../../src/app/error/error.module.ts",
		"error.module"
	],
	"./views/admin/admin.module": [
		"../../../../../src/app/views/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"./views/calculation/calculation.module": [
		"../../../../../src/app/views/calculation/calculation.module.ts",
		"common"
	],
	"./views/dashboard/dashboard.module": [
		"../../../../../src/app/views/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./views/input/input.module": [
		"../../../../../src/app/views/input/input.module.ts",
		"common",
		"input.module"
	],
	"./views/output/output.module": [
		"../../../../../src/app/views/output/output.module.ts",
		"common",
		"output.module"
	],
	"./views/profile/profile.module": [
		"../../../../../src/app/views/profile/profile.module.ts",
		"common",
		"profile.module"
	],
	"./views/references/references.module": [
		"../../../../../src/app/views/references/references.module.ts",
		"common",
		"references.module"
	],
	"./views/report/report.module": [
		"../../../../../src/app/views/report/report.module.ts",
		"common",
		"report.module"
	],
	"./views/settings/settings.module": [
		"../../../../../src/app/views/settings/settings.module.ts",
		"common",
		"settings.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main